<template>
    <div>
        <b-tabs v-model="activetab" pills content-class="m-0" card>
            <b-tab :title="$t('Produkter')" no-body lazy>
                <AdminProductList :data="products" product-name="slutbleck" product-code="sb" @on-deleted-item="fetchSb"></AdminProductList>
            </b-tab>
            <b-tab :title="$t('Kriterier')" no-body lazy>
                <AdminSbOptionsList></AdminSbOptionsList>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import AdminProductList from '@/components/admin/AdminProductList';
    import AdminSbOptionsList from "@/components/admin/AdminSbOptionsList";
    import ApiServiceAdmin from "@/services/ApiServiceAdmin";
    export default {
        components: {
            AdminProductList,
            AdminSbOptionsList
        },
        data() {
            return {
                products: [],
                totalForSlug: {},
                activetab: 0
            }
        },
        methods: {
            fetchSb() {
                ApiServiceAdmin.getSb().then((response) => {
                    this.products = response.data;
                });
            },
        },
        mounted() {
            this.fetchSb();
        },
    }

</script>